import { Injectable, inject } from '@angular/core';
import { ActivatedRouteSnapshot } from '@angular/router';

import { Store } from '@ngrx/store';
import { tap, filter, take, switchMap, catchError, withLatestFrom, map } from 'rxjs/operators';

import * as fromStore from '../store';
import { Observable, of } from 'rxjs';
import * as fromRoot from '../../store';

@Injectable({ providedIn: 'root' })
export class DiseaseProfilesGuard {
  private store = inject<Store<fromStore.DiseaseProfileState>>(Store);


  canActivate(): Observable<boolean> {
    return this.checkStore().pipe(
      switchMap(() => of(true)),
      catchError(() => of(false))
    );
  }

  checkStore(): Observable<boolean> {
    return this.store.select(fromStore.getDiseaseProfilesLoaded).pipe(
      withLatestFrom(this.store.select(fromRoot.getRouterState), this.store.select(fromStore.getDiseaseProfilesPage)),
      tap(([loaded, router, page]) => {
        if (
          !loaded ||
          (+router.state.queryParams?.['page'] || 0) !== page.current ||
          (router.state.queryParams?.['q'] || '') !== page.query
        ) {
          const p = +router.state.queryParams?.['page'] || 0;
          const q = router.state.queryParams?.['q'] || '';
          this.store.dispatch(fromStore.LoadDiseaseProfiles({ skip: p * page.size, take: page.size, q: q }));
        }
      }),
      map(([loaded, router]) => loaded),
      filter(loaded => loaded),
      take(1)
    );
  }
}
